module.exports = __webpack_public_path__ + "media/images/mobile/service/m_data-ba3ff0e0e55855e2f94fe0b1d8583212.jpg";